
<template>
  <t-layout>
    <t-aside>
      <Header></Header>
    </t-aside>
    <t-layout>
      <t-content style="min-height: 100vh;">
        <div style="padding:20px;">
          <div class="flex space-between">
            <div><span class="c-main fs-26 fw-600">产品编辑</span></div>
            <div></div>
          </div>
          <div style="width:60%;padding:20px;background-color:#fff;border-radius: 8px;" class="mt-20">
            <t-form>
              <t-form-item label="产品图片" name="product_img">
                <t-upload ref="uploadProductImg"
                          :size-limit="imgSizeLimit"
                          action="/api/common/fileUpload"
                          theme="image"
                          tips="图片上传"
                          accept="image/*"
                          v-model="uploadImg"
                          :auto-upload="autoUpload"
                          :show-image-file-name="showImageFileName"
                          :upload-all-files-in-one-request="uploadAllFilesInOneRequest"
                          :format-response="uploadResponse"
                          :locale="{
                            triggerUploadText: {
                              image: '请选择图片',
                            },
                          }"
                          @fail="handleFail"
                >
                </t-upload>
              </t-form-item>
              <t-form-item label="产品名称" name="name" >
                <t-input placeholder="请输入产品名称" v-model="productFormData.name"/>
              </t-form-item>
              <t-form-item label="产品类别" name="cat_id" >
                <t-select v-model="productFormData.cat_id">
                  <t-option key="1" label="手工夹芯板" value="1" />
                  <t-option key="2" label="机制夹芯板" value="2"/>
                  <t-option key="3" label="洁净门/窗" value="3" />
                  <t-option key="3" label="净化设备" value="4" />
                  <t-option key="4" label="洁净配件" value="5" />
                  <t-option key="5" label="通风管道" value="6" />
                </t-select>
              </t-form-item>
              <t-form-item label="产品介绍" name="product_desc" >
                <t-textarea placeholder="请输入产品介绍" v-model="productFormData.product_desc"/>
              </t-form-item>
              <t-form-item label="产品用途" name="use_comment" >
                <t-textarea placeholder="请输入产品用途" v-model="productFormData.use_comment"/>
              </t-form-item>
              <t-form-item label="产品规格" name="specifications" >
                <div style="width:100%;">
                  <div class="flex space-between" style="width:100%;">
                    <div></div>
                    <div @click="addSpecifications"><AddCircleIcon  class="c-main cursor-pointer"/><span class="fs-12 cursor-pointer c-main">添加</span></div>
                  </div>
                  <div class="flex align-items-center mt-10" v-for="(sitem,index) in productFormData.specifications">
                    <div class="flex"><t-input placeholder="请输入属性" v-model="sitem.label"/></div>
                    <span class="ml-10">:</span>
                    <div class="flex ml-10" style="width:50%"><t-input placeholder="请输入值" v-model="sitem.value"/></div>
                    <div class="ml-10"><DeleteIcon class="c-main cursor-pointer" @click="deleteSpecifications(index)"/></div>
                  </div>
                </div>
              </t-form-item>
              <t-form-item label="产品质量标准" name="quality_standard" >
                <div style="width:100%;">
                  <div class="flex space-between" style="width:100%;">
                    <div></div>
                    <div @click="addQualityStandard"><AddCircleIcon  class="c-main cursor-pointer"/><span class="fs-12 cursor-pointer c-main">添加</span></div>
                  </div>
                  <div class="flex align-items-center mt-10" v-for="(qitem,index) in productFormData.quality_standard">
                    <div class="flex" ><t-input placeholder="请输入属性" v-model="qitem.label"/></div>
                    <span class="ml-10">:</span>
                    <div class="flex ml-10" style="width:50%"><t-input placeholder="请输入值" v-model="qitem.value"/></div>
                    <div class="ml-10"><DeleteIcon class="c-main cursor-pointer" @click="deleteQualityStandard(index)"/></div>
                  </div>
                </div>
              </t-form-item>
              <t-form-item label="产品排序" name="sort_id" >
                <t-input type="number" placeholder="请输入产品排序" v-model="productFormData.sort_id"/>
              </t-form-item>
              <t-form-item>
                <t-space size="small">
                  <t-button theme="primary" @click="addProductAct">提交</t-button>
                </t-space>
              </t-form-item>
            </t-form>

          </div>
        </div>
      </t-content>
    </t-layout>
  </t-layout>
</template>
<script setup>

import Header from "@/components/header.vue";
import {MessagePlugin} from "tdesign-vue-next";
import {onMounted, reactive, ref} from "vue";
import {AddCircleIcon, AddIcon, DeleteIcon} from "tdesign-icons-vue-next";
import {productAddApi, productDetailApi} from "@/api/product"
import {useRoute} from "vue-router";
// const domainUrl = ref("http://localhost:8082")
const domainUrl = ref("https://www.hdcleanroom.com")
const productFormData = reactive({
  name: '',
  product_desc: '',
  product_img: '',
  use_comment: '',
  specifications:[],
  quality_standard: [],
  cat_id: "",
  sort_id: "999",
  id: "0"
});
const uploadImg = ref([]);
onMounted(() => {
  let router = useRoute()
  if (router.query.id !== undefined) {
    productDetailApi({id:router.query.id}).then(res => {
      if (res.data.code === 200) {
        let detail = res.data.data.detail
        productFormData.id = detail.id
        productFormData.name = detail.name
        productFormData.product_img = detail.product_img
        productFormData.use_comment = detail.use_comment
        productFormData.product_desc = detail.product_desc
        productFormData.cat_id = detail.cat_id
        productFormData.sort_id = detail.sort_id
        productFormData.specifications = JSON.parse(detail.specifications)
        productFormData.quality_standard = JSON.parse(detail.quality_standard)

        uploadImg.value = [{ name: '', url: domainUrl.value+productFormData.product_img }]
      }
    })
  }
})

const autoUpload = ref(true);
const imgSizeLimit = ref({ size: 2, unit: 'MB' });
const showImageFileName = ref(false);
const uploadAllFilesInOneRequest = ref(false);
const handleFail = ({ file }) => {
  MessagePlugin.error(`文件 ${file.name} 上传失败`);
};


function uploadResponse(res) {
  productFormData.product_img = res.data.file_url;
  return res;
}

const addSpecifications = () => {
  let tmp = {
    label:"",
    value: "",
  }

  productFormData.specifications.push(tmp)
}

const addQualityStandard = () => {
  let tmp = {
    label:"",
    value: "",
  }

  productFormData.quality_standard.push(tmp)
}

const deleteQualityStandard = (i) => {
  productFormData.quality_standard.splice(i, 1)
}

const deleteSpecifications = (i) => {
  productFormData.specifications.splice(i, 1)
}


const addProductAct = () => {
  if (productFormData.name === "") {
    MessagePlugin.warning('产品名称必填');
    return
  }

  if (productFormData.product_img === "") {
    MessagePlugin.warning('请上传产品图片');
    return
  }

  for (let i=0; i<productFormData.specifications.length; i++) {
    if (productFormData.specifications[i].label === "" || productFormData.specifications[i].value === "") {
      productFormData.specifications.splice(i, 1);
    }
  }

  for (let i=0; i<productFormData.quality_standard.length; i++) {
    if (productFormData.quality_standard[i].label === "" || productFormData.quality_standard[i].value === "") {
      productFormData.quality_standard.splice(i, 1);
    }
  }

  let postData = {
    id: parseInt(productFormData.id),
    name: productFormData.name,
    product_desc: productFormData.product_desc,
    product_img: productFormData.product_img,
    use_comment: productFormData.use_comment,
    specifications:JSON.stringify(productFormData.specifications),
    quality_standard: JSON.stringify(productFormData.quality_standard),
    cat_id: productFormData.cat_id,
    sort_id: parseInt(productFormData.sort_id),
  }

  productAddApi(postData).then(res => {
    if (res.data.code === 200) {
      MessagePlugin.success("产品成功编辑！")
      setTimeout(() => {
        location.reload();
      }, 2000);
    } else {
      MessagePlugin.error(res.data.msg)
    }
  })


}
</script>

<style scoped>

</style>